import { taxAPI } from './api';
import Swal from 'sweetalert2';

export const taxActions = {
    // Fetch all taxes with filters
    fetchTaxes: (filters = {}) => {
        return async (dispatch) => {
            try {
                const response = await taxAPI.list({
                    page: filters.page || 1,
                    limit: filters.limit || 10,
                    search: filters.search || '',
                    tax_code: filters.tax_code || '',
                    date: filters.date || '',
                    sort_by: filters.sort_by || 'created_at',
                    sort_order: filters.sort_order || 'DESC'
                });
                
                if (response.status) {
                    dispatch({
                        type: "Tax_list",
                        payload: response.data.taxes
                    });
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching taxes:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch tax rates',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to fetch tax rates'
                };
            }
        };
    },
    
    // Get single tax
    fetchTaxById: (id) => {
        return async () => {
            try {
                const response = await taxAPI.get(id);
                
                if (response.status) {
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching tax:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch tax rate'
                };
            }
        };
    },
    
    // Create tax
    createTax: (taxData) => {
        return async (dispatch) => {
            try {
                const response = await taxAPI.create(taxData);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Tax rate created successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh tax list
                    dispatch(taxActions.fetchTaxes());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error creating tax:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to create tax rate',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to create tax rate'
                };
            }
        };
    },
    
    // Update tax
    updateTax: (id, taxData) => {
        return async (dispatch) => {
            try {
                const response = await taxAPI.update(id, taxData);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Tax rate updated successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh tax list
                    dispatch(taxActions.fetchTaxes());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error updating tax:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to update tax rate',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to update tax rate'
                };
            }
        };
    },
    
    // Delete tax
    deleteTax: (id) => {
        return async (dispatch) => {
            try {
                const response = await taxAPI.delete(id);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Tax rate deleted successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh tax list
                    dispatch(taxActions.fetchTaxes());
                    
                    return {
                        success: true
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error deleting tax:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to delete tax rate',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to delete tax rate'
                };
            }
        };
    }
};